import { render, staticRenderFns } from "./Pl5.vue?vue&type=template&id=5a64c308&scoped=true"
import script from "./Pl5.vue?vue&type=script&lang=js"
export * from "./Pl5.vue?vue&type=script&lang=js"
import style0 from "./Pl5.vue?vue&type=style&index=0&id=5a64c308&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a64c308",
  null
  
)

export default component.exports